
import { isString, map, each, filter } from 'lodash';
import { User } from '../user/user';
import { Record, RecordField } from '../record/record';
import { RecordLink } from '../record-link/record-link';
import { DocumentField } from '../document/document';
import { Operation } from '../operation/operation';
import { Revision } from '../revision/revision';
import { Dossier } from '../dossier/dossier';
import { DossierModel } from '../dossier-model/dossier-model';

export class ExecutionDossier {
  id: string

  root_field: string

  dossier: Dossier

  constructor(data: any = {}) {
    Object.assign(this, data);

    if (this.dossier) {
      this.dossier = new Dossier(this.dossier);
    }
  }
}

export class Execution {
  id: string

  fields: RecordField[] = []
  fields_model: DocumentField[] = []

  operation: Operation
  revision: Revision

  dossiers: ExecutionDossier[] = []

  links: RecordLink[] = []

  dossier_model: DossierModel

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  version: number

  constructor(data: any = {}) {
    Object.assign(this, data);

    if (this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if (this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if (this.fields) {
      this.fields = map(this.fields, f => new RecordField(f));
    }

    if (this.fields_model) {
      this.fields_model = map(this.fields_model, f => new DocumentField(f));
    }

    if (this.operation) {
      this.operation = new Operation(this.operation);
    }

    if (this.revision) {
      this.revision = new Revision(this.revision);
    }

    if (this.dossiers) {
      this.dossiers = map(this.dossiers, d => new ExecutionDossier(d));
    }

    if (this.links) {
      this.links = map(this.links, l => new RecordLink(l));
    }

    if (this.dossier_model) {
      this.dossier_model = new DossierModel(this.dossier_model.toString());
    }
  }

  get valid(): boolean {
    return true;
  }

  toCreateExecutionInput() {
    return {
      operation_id: this.operation.id,
      revision_id: this.revision.id,
      dossiers: map(this.dossiers, d => ({
        id: d.id,
        root_field: d.root_field,
      })),
      links: map(this.links, l => l.id)
    };
  }

  toUpdateExecutionInput() {
    return {
      version: this.version,
      fields: map(this.fields, f => f.toRecordFieldInput())
    };
  }
}
